<script>
	  export let secondaryRatings = [], title =''

	  let lang = document.querySelector('html').lang || 'en'

	  const labels = {
		en: {
			'Quality': 'Quality',
			'Value': 'Value',
			'Durability': 'Durability',
		},
		fr: {
			'Quality': 'Qualité',
			'Value': 'Valeur',
			'Durability': 'Durabilité',
		}
	  }
	  $:console.log('secondaryRatings in SecondaryStatsComponent:', secondaryRatings);
</script>
<section class="CustomerRatings">
	{#if title}
		<h4>{title}</h4>
	{/if}
	<div>
		{#each secondaryRatings as secondaryRatingAttr}
			{@const fillPercentage = Math.max(1, Math.min(100, (+(secondaryRatingAttr.rating )/ 5) * 100)) }
			<div>
				<p>{labels[lang][secondaryRatingAttr.name] || secondaryRatingAttr.name}</p>
				<div>
					<div class="RatingBar" data-rating={secondaryRatingAttr.rating} style={`--fill: ${fillPercentage}%`}></div>
					<div class="RatingValue">{secondaryRatingAttr.rating.toFixed(1)}</div>
				</div>
			</div>
		{/each}
	</div>
</section>